import ajax from '@/utils/ajax'

/**
 * @module 活动冲单
 */

/**
 * 活动报名
*/

// 查询活动日期
export const searchActiveDate = params => ajax.post('/offsetOrder/info4BeforeSignUp', params)

// 表单提交
export const submitInfo = params => ajax.post('/offsetOrder/signup', params)

// 活动详情
export const activeDetail = params => ajax.post('/offsetOrder/detail', params)

// 营销数据
export const getOverview = params => ajax.post('/offsetOrder/marketData', params)

/**
 * 活动列表
 */
export const cancelActive = params => ajax.post('/offsetOrder/cancel', params)
